/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from '@mui/material/Box';

// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2020/06/data-studio-extract-google-analytics-errors/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/06/data-studio-extract-google-analytics-errors/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/06/data-studio-extract-google-analytics-errors/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Data Studio Extract: Discrepancies with Google Analytics and other Google tools - Why is the Data from Data Studio Extract and Google Analytics Different? - Tribalism",
  date: "2020-06-17",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. We take a look at why data from Data Studio Extract and Google Analytics different. Stop pulling your hair out - yes, it's a thing! Data Studio extract data will not match Google Analytics and other tools, read on for more.",
  image: "/img/posts/2020-06-17-DataStudioExtractsProblems/errors.webp",
  url: "https://www.tribalism.com.au/blog-post/2020/06/data-studio-extract-google-analytics-errors",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Why is the Data from Data Studio Extract and Google Analytics Different? - Tribalism"
        image="/img/posts/2020-06-17-DataStudioExtractsProblems/errors.webp"
        url="https://www.tribalism.com.au/blog-post/2020/06/data-studio-extract-google-analytics-errors"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. We take a look at why data from Data Studio Extract and Google Analytics different."

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-06-17-DataStudioExtractsProblems/errors.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <Box 
                sx={{
                  '& h1': {
                    fontSize: {
                      xs: '1.5rem',
                      sm: '2rem',
                      md: '2.5rem',
                      lg: '3rem',
                      xl: '5rem'
                    }
                  }
                }}
              >
                <h1 className={classes.title}>
                  Data Studio Extract: Discrepancies with Google Analytics and other Google tools
                </h1>
              </Box>
              <h4 className={classes.subtitle}>
                Stop pulling your hair out - yes its a thing! Data Studio extract data will not match Google Anlaytics and other tools, read on for more
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />
      <Footer
        
      />
    </div>
  );
}
